import _ic_checkbox_checked from "./checkbox-checked.svg";

export const IC_CHECKBOX_CHECKED = _ic_checkbox_checked;
